import { POST, GET, DELETE } from "../method.js";
import { ENDPOINTS } from "../ApiConstants.js";

export const passkeyRegisterInitAPI = async () => {
	const url = ENDPOINTS.PASSKEY_REGISTER_INIT;
	return GET(url);
};

export const passkeyRegisterAPI = async (data) => {
	const url = ENDPOINTS.PASSKEY_REGISTER;
	return POST(url, data);
};

export const fetchPasskeyListAPI = async () => {
  const url = ENDPOINTS.PASSKEY_LIST;
  return GET(url);
};

export const passkeySignInInitAPI = async () => {
  const url = ENDPOINTS.PASSKEY_SIGNIN_INIT;
  return GET(url);
};

export const passkeySignInAPI = async (data) => {
  const url = ENDPOINTS.PASSKEY_SIGNIN;
  return POST(url, data);
};

export const deletePasskeyAPI = async (data) => {
  const url = ENDPOINTS.PASSKEY_ID_DELETE;
  return DELETE(url, data);
}